import axios from 'axios'
import {asResponse} from '../util'

export const CONFLICTS_SWR_KEY = ({versionId}) => [
  '/bff/versions/${versionId}/conflicts',
  versionId
]


export const getConflicts = async (url, versionId) => {
  if (!versionId) {
    return {
      conflicts: []
    }
  }
  const resp = await asResponse(axios.get(url.replace('${versionId}', versionId)))
  return {
    conflicts: resp.data
  }
}
